module.exports = __webpack_public_path__ + "img/sibi-sign-language-react-native-thumbnail.c6560ba7.png";